// ./src/utils/api/ServicesBookingService.ts
//
// ROADMAP A1 — where the signed-in account books the services it bought (eventsmagic-api `servicesBookingGet`: the
// brand's `space.settings.services.schedulingUrl`, answered only to an account that holds a service). The Subscription
// page's "Services you've bought" card links it; without it (none set, or the read failed) the card points at the
// receipt email as before.
import { gql } from "@apollo/client";
import { OpResult } from "@sdflc/api-helpers";

import { ApiService } from "./ApiService";

const BOOKING_QUERY = gql`
  query ServicesBookingGet {
    servicesBookingGet {
      code
      data { holdsService schedulingUrl }
      errors { name errors warnings }
    }
  }
`;

export interface ServicesBooking {
  holdsService?: boolean | null;
  /** The brand's booking page; null when the account holds no service or the brand has none set. */
  schedulingUrl?: string | null;
}

export class ServicesBookingService {
  static async get(): Promise<OpResult> {
    return ApiService.executeQuery(BOOKING_QUERY, {}, { fetchPolicy: "network-only" });
  }
}
